import { motion } from "framer-motion";

const nodes = [
  { id: "habitat", label: "Habitat Node", x: 80, y: 40, desc: "Breathing Zone" },
  { id: "airlock", label: "Airlock Node", x: 280, y: 40, desc: "Suitport Threshold" },
  { id: "rover", label: "Rover Node", x: 480, y: 40, desc: "Ingress Zone" },
  { id: "core", label: "ControlCore", x: 280, y: 180, desc: "Event Inference" },
];

const connections = [
  { from: "habitat", to: "core", x1: 130, y1: 75, x2: 280, y2: 175 },
  { from: "airlock", to: "core", x1: 330, y1: 75, x2: 330, y2: 175 },
  { from: "rover", to: "core", x1: 530, y1: 75, x2: 380, y2: 175 },
];

export default function SystemDiagram() {
  return (
    <div data-testid="system-diagram" className="relative w-full max-w-[600px]">
      <svg viewBox="0 0 600 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg">
        {/* Grid lines */}
        {Array.from({ length: 11 }).map((_, i) => (
          <line key={`vg-${i}`} x1={i * 60} y1={0} x2={i * 60} y2={260} stroke="#2d3239" strokeWidth={0.5} opacity={0.4} />
        ))}
        {Array.from({ length: 6 }).map((_, i) => (
          <line key={`hg-${i}`} x1={0} y1={i * 52} x2={600} y2={260 > 0 ? i * 52 : 0} stroke="#2d3239" strokeWidth={0.5} opacity={0.4} />
        ))}

        {/* Connection lines */}
        {connections.map((conn, i) => (
          <g key={conn.from + conn.to}>
            <line
              x1={conn.x1} y1={conn.y1} x2={conn.x2} y2={conn.y2}
              stroke="#4b7399" strokeWidth={1.5} strokeDasharray="6 4"
              opacity={0.4}
            />
            <motion.line
              x1={conn.x1} y1={conn.y1} x2={conn.x2} y2={conn.y2}
              stroke="#4b7399" strokeWidth={2}
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: [0.2, 0.8, 0.2] }}
              transition={{ duration: 3, delay: i * 0.8, repeat: Infinity, repeatType: "loop" }}
            />
          </g>
        ))}

        {/* Nodes */}
        {nodes.map((node, i) => (
          <g key={node.id}>
            <motion.rect
              x={node.x} y={node.y} width={100} height={35} rx={0}
              fill="#121519" stroke={node.id === "core" ? "#4b7399" : "#2d3239"} strokeWidth={node.id === "core" ? 2 : 1}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            />
            <text x={node.x + 50} y={node.y + 15} textAnchor="middle" fill="#f2f4f8" fontSize={10} fontFamily="IBM Plex Mono, monospace" fontWeight={500}>
              {node.label}
            </text>
            <text x={node.x + 50} y={node.y + 28} textAnchor="middle" fill="#8c9eb3" fontSize={8} fontFamily="IBM Plex Mono, monospace">
              {node.desc}
            </text>

            {/* Amber alert flash on airlock node */}
            {node.id === "airlock" && (
              <motion.rect
                x={node.x} y={node.y} width={100} height={35} rx={0}
                fill="none" stroke="#d97706" strokeWidth={2}
                initial={{ opacity: 0 }}
                animate={{ opacity: [0, 0, 0.8, 0.8, 0] }}
                transition={{ duration: 5, delay: 2, repeat: Infinity }}
              />
            )}
          </g>
        ))}

        {/* ECLSS Output */}
        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          <rect x={180} y={230} width={80} height={22} fill="none" stroke="#2d3239" strokeWidth={1} strokeDasharray="3 3" />
          <text x={220} y={244} textAnchor="middle" fill="#8c9eb3" fontSize={7} fontFamily="IBM Plex Mono, monospace">
            ECLSS I/F
          </text>
          <line x1={220} y1={215} x2={220} y2={230} stroke="#2d3239" strokeWidth={1} strokeDasharray="3 3" />
        </motion.g>

        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <rect x={340} y={230} width={80} height={22} fill="none" stroke="#2d3239" strokeWidth={1} strokeDasharray="3 3" />
          <text x={380} y={244} textAnchor="middle" fill="#8c9eb3" fontSize={7} fontFamily="IBM Plex Mono, monospace">
            Telemetry Out
          </text>
          <line x1={380} y1={215} x2={380} y2={230} stroke="#2d3239" strokeWidth={1} strokeDasharray="3 3" />
        </motion.g>
      </svg>
    </div>
  );
}
